import { useEffect, useRef, useState } from "react";
import { useGoogleMapsScript } from "../../useScript";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

type WithGoogleProps = {
    children: (
        googlePlaceService: google.maps.places.PlacesService,
    ) => React.JSX.Element;
};

function WithGoogle(props: WithGoogleProps) {
    const { children } = props;
    const [googlePlaceService, setGooglePlaceService] = useState<
        google.maps.places.PlacesService | undefined
    >(undefined);

    const googlePlacesRef = useRef<HTMLDivElement>(null);
    const scriptLoadStatus = useGoogleMapsScript();

    useEffect(() => {
        if (scriptLoadStatus === "ready" && window.google && googlePlacesRef.current) {
            const service = new google.maps.places.PlacesService(
                googlePlacesRef.current,
            );
            setGooglePlaceService(service);
        }
    }, [scriptLoadStatus, googlePlacesRef.current]);

    return (
        <>
            <div ref={googlePlacesRef} />
            {googlePlaceService ? children(googlePlaceService) : <LoadingSpinner />}
        </>
    );
}

export default WithGoogle;
